import { Affix, Button } from "antd";
import { useNavigate } from "react-router-dom";
import style from './Affix.module.css'

export const AffixVideo = () => {
    const navi = useNavigate()
    return (
        <div className={style.affix}>
                <Button ghost style={{opacity:0.4}}
                    onClick={() => { navi("/video") }}
                ><label style={{fontSize:"12px"}}>Video Portfolio</label></Button>
        </div>
    );
}

export const AffixWebDev = () => {
    const navi = useNavigate()
    return (
        <div className={style.affix}>
            <Affix>
                <Button ghost
                    onClick={() => { navi("/") }}
                >Home</Button>
            </Affix>
        </div>
    );
}